import { memo } from 'react';
import PropTypes from 'prop-types';
import styles from './emptyMessage.module.scss';

export const EmptyMessage = memo(({ children }) => <div className={styles.container}>{children}</div>);

EmptyMessage.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};
